import { apiClient } from "@/shared/lib/api/client";

/** Permissao de envio de dados a IA (consentimento-ia.md). O texto vem da API. */
export type ConsentimentoIa = {
  versao: number;
  aceito: boolean;
  aceitoEm: string | null;
  titulo: string;
  paragrafos: string[];
};

export const consentimentoIaService = {
  obter: async (): Promise<ConsentimentoIa> => {
    const { data } = await apiClient.get<ConsentimentoIa>(
      "/v1/ia/consentimento",
    );
    return data;
  },
  aceitar: async (versao: number): Promise<ConsentimentoIa> => {
    const { data } = await apiClient.post<ConsentimentoIa>(
      "/v1/ia/consentimento",
      { versao },
    );
    return data;
  },
  revogar: async (): Promise<void> => {
    await apiClient.delete("/v1/ia/consentimento");
  },
};
